import { useFormik } from "formik";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Link, useHistory, useParams, withRouter } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";
import { object, string } from "yup";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import {
  useArrondissementsByCity,
  useQuartier,
  useUpdateQuartier,
} from "../../../hooks/useGeography";

const UpdateQuartier = (props) => {
  const history = useHistory();
  const { id } = useParams();
  const quartierQ = useQuartier(id);
  const updateQuartierMutation = useUpdateQuartier();
  const arrondissementsQ = useArrondissementsByCity(quartierQ.data?.city);

  document.title = props.t("Modification d'un quartier - Le Conseiller du BTP");

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      name: quartierQ.data?.name || "",
      arrondissement: quartierQ.data?.arrondissement || "",
    },

    validationSchema: object().shape({
      name: string().required(props.t("Veuillez entrer le nom du quartier")),
    }),

    onSubmit: async (values) => {
      updateQuartierMutation.mutate(
        {
          id: quartierQ.data?.id,
          name: values.name,
        },
        {
          onSuccess: () => {
            history.push("/geolocalisation-quartier");
          },
        }
      );
    },
  });

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={props.t("Ajout d'un quartier")}
          pageTitle={props.t("Quartier")}
        />

        <Row>
          <Col lg={12}>
            <Form
              encType="multipart/form-data"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
              }}
            >
              <Card>
                <CardBody>
                  {quartierQ.isLoading ? (
                    <div className="py-4 text-center">
                      <div className="mt-4">
                        <h5>{props.t("Chargement")}...</h5>
                      </div>
                    </div>
                  ) : quartierQ.error ? (
                    <div className="py-4 text-center">
                      <div className="mt-4">
                        <h5>
                          {quartierQ.error.message ||
                            props.t("Une erreur est survenue")}
                        </h5>
                      </div>
                    </div>
                  ) : (
                    <>
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="arrondissement">
                      {props.t("Arrondissement")}
                    </Label>
                    <Input
                      type="select"
                      className="form"
                      placeholder={props.t("Entrer le nom de l'arrondissement")}
                      name="arrondissement"
                      value={validation.values.arrondissement}
                      disabled
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                      required
                    >
                      <option value="">
                        {props.t("Choisir un arrondissement")}
                      </option>
                      {(arrondissementsQ.data || []).map((p) => (
                        <option key={p.id} value={p.id}>
                          {p.name}
                        </option>
                      ))}
                    </Input>
                    {validation.errors.arrondissement &&
                    validation.touched.arrondissement ? (
                      <FormFeedback type="invalid">
                        {validation.errors.arrondissement}
                      </FormFeedback>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="name">
                      {props.t("Nom du quartier")}
                    </Label>
                    <Input
                      type="text"
                      className="form"
                      placeholder={props.t("Entrer le nom du quartier")}
                      name="name"
                      value={validation.values.name}
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                      required
                    />
                    {validation.errors.name && validation.touched.name ? (
                      <FormFeedback type="invalid">
                        {validation.errors.name}
                      </FormFeedback>
                    ) : null}
                  </div>
                    </>
                  )}
                </CardBody>
              </Card>
              <div className="text-end mb-3">
                <Link to="/geolocalisation-quartier" className="btn btn-primary me-2">
                  {props.t("Retour")}
                </Link>
                <button
                  type="submit"
                  className="btn btn-warning w-sm m-2"
                  disabled={quartierQ.isLoading || updateQuartierMutation.isPending}
                >
                  {props.t("Valider")}
                </button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

UpdateQuartier.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(UpdateQuartier));
